import React, { useCallback, useContext } from 'react';

import { TypeDefinitionContext } from '../../type-definition.context';
import WorkEquipmentTypeDefinitonForm from '../Form';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(TypeDefinitionContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <WorkEquipmentTypeDefinitonForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
